<template>
<div class="container">
  <div class="hello">
    <div class="content-left">
      <img src="../assets/giropos.png" alt="">
      <p>GIRO POS INDONESIA</p>
    </div>
    <div class="content-right">
      <p class="notice-congrat">Selamat!</p>
      <p class="notice">Akun Anda terverfikasi <b-icon icon="award" class="icon"></b-icon></p>
      <form>
          <div class="form-group">
            <input type="text" class="form-input" placeholder="0183016809 - Bagus Ali">
          </div>
      </form>
      <p class="notice">Silahkan login kembali untuk menyelesaikan proses </p>
      <button class="btn-primer">Reset</button>
    </div>  
  </div>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.hello{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85vh;
}

.content-left{
  flex: 1;
  text-align: right;
}

.content-left img{
  width: 159px;
  height: 159px;
  margin: 0 10px;
}

.content-left p{
   font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  margin: 20px 0 0 ;
  color: rgba(112, 112, 112, 0.5);
}

.content-right{
  flex: 2;
  padding: 20px;
  margin: 0 0 0 79px;
}

.form-input{
  width: 228px;
  height: 50px;
}

.notice-congrat{
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  margin: 0 0 -15px;
}

.notice{
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  margin: 35px 0;
  position: relative;
}

.icon{
    color: #1524eb;
    font-size: 29px;
    position: absolute;
    left: 34%;
}
</style>